module.exports = __webpack_public_path__ + "92854582a956f594a07ca07b58d6281c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/trumpet.png
// module id = 2445
// module chunks = 0